<header class="header">
    <div class="header__title">
        <div class="toggle" (click)="setMenu()">
            <img *ngIf="!isActive" src="assets/img/menu.png" class="toggle-menu">
            <img *ngIf="isActive" src="assets/img/close.png" class="toggle-menu">
        </div>

        <img src="assets/img/logo.png" class="brand">
    </div>

    <div class="header__menu" [ngClass]="{'active': isActive}">
        <nav class="header__nav">
            <a routerLinkActive="header__nav-item-active" (click)="setMenu()" routerLink="resumen"
                class="header__nav-item">resumen</a>
            <a routerLinkActive="header__nav-item-active" (click)="setMenu()" routerLink="tarjetas/movimientos"
                class="header__nav-item" href="comerciales"> medios de acceso</a>
            <a routerLinkActive="header__nav-item-active" (click)="setMenu()" routerLink="ubicaciones/centrosAtencion"
                class="header__nav-item">Ubicaciones</a>
            <a routerLinkActive="header__nav-item-active" (click)="setMenu()" routerLink="perfil"
                class="header__nav-item" href="usuarios">Perfil</a>
        </nav>
    </div>

    <div class="header__user">
        <div class="dropdown">
            <button class="btn btn-close" (click)="closeSession()">Cerrar sesión</button>
        </div>
    </div>
</header>